import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { CellTotalMarginComponent } from "./cell-total-margin.component";
import { TdPercentModule } from "libraries/component/table/td-percent/td-percent.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormBuilderModule } from "libraries/module/formbuilder/form-builder.module";
import { NumberModule } from "libraries/module/formbuilder/fields/number/number.module";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { ThTextModule } from "libraries/component/table/th-text/th-text.module";
import { MatTableModule } from "@angular/material/table";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        TdPercentModule,
        MatMenuModule,
        MatRadioModule,
        FormsModule,
        ReactiveFormsModule,
        FormBuilderModule,
        NumberModule,
        ConfigurationResourceModule,
        BtnModule,
        ThTextModule,
    ],
    exports: [
        CellTotalMarginComponent,
    ],
    declarations: [
        CellTotalMarginComponent,
    ],
    providers: [],
})
export class CellTotalMarginModule {}
